import * as Yup from "yup";
import {INVALID_EMAIL_MESSAGE, REQUIRED_FIELD_MESSAGE} from "../../constants";

export const connectorEnabledTenantInputSectionYupSchema: Yup.ObjectSchema<ConnectorEnabledTenantInputSectionSchema> = Yup.object().shape({
  document: Yup.string()
    .required(REQUIRED_FIELD_MESSAGE)
    .isValidDocument(),
  name: Yup.string().required(REQUIRED_FIELD_MESSAGE),
  email: Yup.string().required(REQUIRED_FIELD_MESSAGE).isValidEmailWithoutAccents(),
  telephone: Yup.string().required(REQUIRED_FIELD_MESSAGE).isValidMaskedTelephone()
});

export type ConnectorEnabledTenantInputSectionSchema = {
  document: string;
  name: string;
  email: string;
  telephone: string;
}
